import { useStore } from 'zustand';
import { WalletContext } from '../context/walletContext';
import { StoreState } from '../store/walletStore';
import { useContext } from 'react';

export function useWalletStore<T>(selector: (state: StoreState) => T): T {
	const store = useContext(WalletContext);
	if (!store) {
		throw new Error('Could not find WalletContext. Ensure that you have set up the WalletProvider.');
	}
	return useStore(store, selector);
}
